import moment from "moment-timezone";

export const ENCOUNTER_INITIAL_VALUES = {
  delete_marker: false,
  discharge_date: "",
  discharge_type: [],
  encounter_date: moment().format("MM/DD/YYYY"),
  encounter_information: "",
  encounter_type: [],
  setting: [],
  setting_other: "",
};

export const ENCOUNTER_SCHEMA = (encounterIndex) => [
  {
    elementClasses: "col-12 col-lg-4",
    elementConfig: {
      label: "Encounter Date",
      placeholder: moment().format("MM/DD/YYYY"),
      type: "text",
    },
    elementType: "datePicker",
    inputClasses: "Input--sm",
    name: `content.encounters[${encounterIndex}].encounter_date`,
    relativeName: "encounter_date",
  },
  {
    elementClasses: "col-12 col-lg-4",
    elementConfig: {
      label: "Discharge Date (if applicable)",
      placeholder: moment().format("MM/DD/YYYY"),
      type: "text",
    },
    elementType: "datePicker",
    inputClasses: "Input--sm",
    name: `content.encounters[${encounterIndex}].discharge_date`,
    relativeName: "discharge_date",
  },
  {
    elementClasses: "col-6",
    elementConfig: {
      label: "Encounter Type",
      options: [
        { display: "Psychiatric", value: "Psychiatric" },
        { display: "Medical", value: "Medical" },
        { display: "SUD", value: "SUD" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    inputClasses: "Input--sm",
    name: `content.encounters[${encounterIndex}].encounter_type`,
    relativeName: "encounter_type",
  },
  {
    elementClasses: "col-6",
    elementConfig: {
      label: "Discharge Type (if applicable)",
      options: [
        { display: "Routine", value: "Routine" },
        { display: "AMA", value: "AMA" },
        { display: "Transfer", value: "Transfer" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    inputClasses: "Input--sm",
    name: `content.encounters[${encounterIndex}].discharge_type`,
    relativeName: "discharge_type",
  },
  {
    elementClasses: "col-12",
    elementConfig: {
      label: "Setting",
      options: [
        { display: "Emergency Room", value: "Emergency Room" },
        { display: "Urgent Care", value: "Urgent Care" },
        { display: "Hospital Admission", value: "Hospital Admission" },
        { display: "Crisis", value: "Crisis" },
        { display: "Other (open text)", openText: true, value: "Other (open text)" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    inputClasses: "Input--sm",
    name: `content.encounters[${encounterIndex}].setting`,
    relativeName: "setting",
  },
  {
    elementClasses: "col-12",
    elementConfig: {
      label: "Encounter Information",
      placeholder: "Type Comment...",
      type: "textArea",
    },
    elementType: "textarea",
    name: `content.encounters[${encounterIndex}].encounter_information`,
  },
];
